import { Facebook, Instagram, Youtube } from "lucide-react";

export const SocialSection = () => {
  return (
    <div>
      <h3 className="text-lg font-bold mb-4 text-white">Suivez-nous</h3>
      <div className="flex flex-col space-y-4">
        <div className="flex space-x-4">
          <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-white transition-colors">
            <Facebook className="h-5 w-5" />
          </a>
          <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-white transition-colors">
            <Instagram className="h-5 w-5" />
          </a>
          <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-white transition-colors">
            <Youtube className="h-5 w-5" />
          </a>
        </div>
      </div>
    </div>
  );
};